// extracted by mini-css-extract-plugin
module.exports = {"totalsWrapper":"_1aIQi","tableWrapper":"_1aBJM"};